export const download = async (exportName, data) => {
  const encodedJSON = decodeURIComponent(encodeURI(JSON.stringify(data)));
  const blob = new Blob([encodedJSON], {
    type: "application/json;charset=utf-8"
  });
  const href = await URL.createObjectURL(blob);
  const downloadAnchorNode = document.createElement("a");
  downloadAnchorNode.setAttribute("href", href);
  downloadAnchorNode.setAttribute("download", `${exportName}.json`);
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
};
